import { useQuery, UseQueryResult } from 'react-query';
import { KiloStaff } from 'types';
import { client } from 'utils/api-client';

function useSelfKiloStaff(): UseQueryResult<{ data: KiloStaff }> {
  return useQuery(['kiloStaff', 'self'], () => client.get(`kilo-staff/self`));
}

export default useSelfKiloStaff;
